module.exports = __webpack_public_path__ + "static/active-barre-20225-ffa08b681581f0bf1fa993351bbefcfc.jpg";